import styled, { css, CSSProp, keyframes } from 'styled-components';

interface BoxStyled {
  img: string;
  centered?: boolean;
  onClick?: () => void;
}

export const Box = styled.div<BoxStyled>`
  background: linear-gradient(
  180deg, rgba(0, 0, 0, 0) 39.82%,
  rgba(0, 0, 0, 0.4) 79.16%), 
  ${({ img }: { img: string }): CSSProp => `url(${img})`},
  #C4C4C4;
  background-position: center;
  position: relative;
  width: 100%;
  margin: 0 10px;
  max-width: 340px;
  height: 340px;
  cursor: ${({ onClick }): string => (onClick ? 'pointer' : 'auto')};
  ${({ centered }): CSSProp => (centered && css`
    background-position: center;
    background-size: cover;
  `) || ''}
  @media screen and (max-width: 1200px) {
    margin: 0 auto;
    margin-bottom: 30px;
  }
`;

const moveCotentAnimation = keyframes`
  from { 
    height: 0; 
    padding: 0 45px; 
  }
  to { 
    height: 100px;
    padding: 37px 45px;
  }
`;

const closeCotentAnimation = keyframes`
  from { 
    height: 100px; 
    padding: 37px 45px;
  }
  to { 
    height: 0; 
    padding: 0 45px; 
  }
`;

export const BoxTitle = styled.p`
  text-align: center;
  width: 100%;
  font-size: 30px;
  color: white;
  margin: 0;
  padding-bottom: 20px;
  font-family: 'Playfair Display',serif;
  letter-spacing: 0.06rem;
  font-style: normal;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 68.88%, rgba(0, 0, 0, 0.4) 87.33%), transparent;
`;

export const BoxInner = styled.div`
  overflow: hidden;
  position: absolute;
  bottom: 0;
  width: 100%;
`;

export const BoxContent = styled.div`
  text-align: center;
  background-color: #DADADA;
  font-family: 'Roboto',serif;
  line-height: 150.2%;
  transition: height 1s;
  height: 0;

  ${({ hovered }: { hovered: boolean }): CSSProp => (hovered ? css`
    animation: ${moveCotentAnimation} .5s ease forwards;
  ` : css`
    animation: ${closeCotentAnimation} .5s ease forwards;
  `)}
`;
